export default class MissingOrEmptyMandatoryFieldError extends Error {
  private fieldName : string;

  constructor(fieldName: string) {
    super();
    this.fieldName = fieldName;
  }
}
